import React, { useState, useEffect } from 'react'
import {
  Modal,
  SelectAsync,
  Select,
  Button
} from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useIntl } from 'react-intl'
import messages from './messages'

export default NiceModal.create(({ refetch, orderId = null }) => {
  const { formatMessage } = useIntl()
  const modal = useModal()
  const [customer, setCustomer] = useState(null)
  const [contact, setContact] = useState(null)
  const [contactOptions, setContactOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (customer) {
      fetch(`/rest/v1/customer/${customer.value}/contacts`)
        .then((response) => response.json())
        .then((items) => setContactOptions(items.map((data) => ({
          value: data.uid,
          label: data.name
        }))))
    }
  }, [customer])

  const loadCustomerOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v2/customer?search[name]=${query}`)
        .then(response => response.json())
        .then(({data}) => {
          resolve(data.map(({ uid, name }) => ({
            value: uid,
            label: name
          })))
        })
        .catch(reject)
    })
  }, 250)

  const onSubmit = () => {
    setLoading(true)

    const body = new FormData()
    body.append('orderId', orderId)
    body.append('customerId', customer.value)
    body.append('contactId', contact.value)

    fetch(`/order/moveOrder.json`, { method: 'POST', body })
    .then((response) => response.json())
    .then(({success, errors}) => {
      setLoading(false)
      if (success) {
        refetch()
        modal.resolve()
        modal.remove()
      } else {
        toastr.error(errors.join(', '))
      }
    }).catch((error) => {
      toastr.error(error)
    })
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => (!customer || loading || !contact) ? undefined : onSubmit()}
      dialogPanelClasses="overflow-y-visible"
      title={formatMessage(messages.title)}
    >
      <div className="m-4 space-y-4">
        <SelectAsync
          required
          label={formatMessage(messages.selectCustomerLabel)}
          description={formatMessage(messages.selectCustomerDescription)}
          value={customer} 
          onChange={(customer) => { setCustomer(customer) }}
          cacheOptions
          loadOptions={(query) => loadCustomerOptions(query)}
          openMenuOnFocus
          placeholder={formatMessage(messages.selectCustomerPlaceholder)}
        />
        <Select
          required
          disabled={!customer}
          value={contact}
          options={contactOptions}
          onChange={(value) => setContact(value)}
          label={formatMessage(messages.selectContactLabel)}
          description={formatMessage(messages.selectContactDescription)}
          placeholder={formatMessage(messages.selectContactPlaceholder)}
        />
      </div>

      <Button
        className="float-right"
        size="sm"
        onClick={() => onSubmit()}
        disabled={!customer || loading || !contact}
      >
        {loading ? formatMessage(messages.moveLoading) : formatMessage(messages.moveOrder)}
      </Button>
    </Modal>
  )
})
